import React, { Fragment, useState } from "react";
import { withStyles } from "@material-ui/core/styles";
import Fab from "@material-ui/core/Fab";
import Tooltip from "@material-ui/core/Tooltip";
import { convertFromRaw, EditorState, convertToRaw } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import SaveIcon from "@material-ui/icons/Save";
import CircularProgress from "@material-ui/core/CircularProgress";
import DetailsSection from "../indicators/details-section";
import Notification from "../../notification";
import useContent from "../../static/data";

const STATIC_MAP = {
	PROJECT: "El Proyecto",
	CREDITS: "Creditos",
	FAQ: "Preguntas Frecuentes",
	REFERENCES: "Citando",
	PUBLICATIONS: "Publicaciones",
	METHODOLOGY: "Metodología"
};

const styles = (theme) => ({
	fab: {
		position: "fixed",
		bottom: theme.spacing.unit * 3,
		right: theme.spacing.unit * 3,
		zIndex: 9999
	},
	toolbarFixed: {
		position: "fixed",
		zIndex: 1000,
		top: 0,
		width: "100%"
	}
});

const InternalEditor = (props) => {
	const { classes, page, onUpdate } = props;
	const [editorState, setEditorState] = useState(props.editorState);
	const [onScroll, setOnScroll] = useState(false);

	const saveContent = (state, page) => {
		const content = state.getCurrentContent();
		onUpdate({ content: convertToRaw(content) }, page);
	};

	setTimeout(() => {
		var header = document.getElementsByClassName("toolbarClassName");
		var sticky = header[0] ? header[0].offsetTop : 0;

		window.onscroll = function() {
			myFunction();
		};

		function myFunction() {
			if (window.pageYOffset > sticky) {
				setOnScroll(true);
			} else {
				setOnScroll(false);
			}
		}
	}, 300);

	return (
		<Fragment>
			<Editor
				toolbarClassName="toolbarClassName"
				wrapperClassName="wrapperClassName"
				editorClassName="editorClassName"
				onEditorStateChange={setEditorState}
				editorState={editorState}
				toolbarStyle={
					onScroll
						? {
								position: "fixed",
								zIndex: 1000,
								top: 0,
								width: "100%"
						  }
						: {}
				}
				wrapperStyle={{ padding: 32, position: "relative" }}
				editorStyle={{ marginTop: 32, position: "relative" }}
			/>
			<div className={classes.fab}>
				<Tooltip title="Guardar contenido" aria-label="Save content">
					<Fab color="primary" onClick={() => saveContent(editorState, page)}>
						<SaveIcon />
					</Fab>
				</Tooltip>
			</div>
		</Fragment>
	);
};

const InternalEditorStyled = withStyles(styles)(InternalEditor);

function getContentState(content) {
	const hasContent = Object.keys(content).length > 0;
	return hasContent
		? EditorState.createWithContent(convertFromRaw(content))
		: EditorState.createEmpty();
}

function getItemContent({ loading, error, data }, title, page, handleUpdate) {
	if (loading) return <CircularProgress />;
	if (error) return `Error!: ${error}`;
	const editorState = getContentState(data.content);
	return (
		<InternalEditorStyled
			editorState={editorState}
			page={page}
			onUpdate={handleUpdate}
		/>
	);
}

const StaticEditor = (props) => {
	const {
		match: {
			params: { page }
		}
	} = props;
	const [notification, setNotification] = useState({
		open: false,
		message: ""
	});
	const title = STATIC_MAP[page];

	const openNotification = (message) => {
		setNotification({
			open: true,
			message: message
		});
	};

	const closeNotification = () => {
		setNotification({
			open: false,
			message: ""
		});
	};

	const state = useContent(page, {
		onUpdate: () => {
			openNotification("Contenido actualizado.");
		},
		onError: () => {
			openNotification("Ocurrió un error al actualizar el contenido.");
		}
	});

	const content = getItemContent(state, title, page, state.update);

	return (
		<Fragment>
			<DetailsSection title={`Editor de ${title}`}>{content}</DetailsSection>
			<Notification
				open={notification.open}
				message={notification.message}
				handleClose={closeNotification}
			/>
		</Fragment>
	);
};

export default StaticEditor;



// WEBPACK FOOTER //
// ./src/components/admin/static/index.js